export default __webpack_public_path__ + "static/media/Simulation.61761227.svg";